export default __webpack_public_path__ + "static/media/39.60ef7285.pdf";